import React from 'react';
import ServiceCard from '../components/ServiceCard';

const Landing = () => {
  const services = [
    {
      type: 'audio',
      title: 'Audio Monitoring',
      description: 'Comprehensive audio media tracking and analysis',
      url: 'https://www.audio.recordnews.co.za'
    },
    {
      type: 'print',
      title: 'Print Monitoring',
      description: 'Traditional print media coverage and mentions',
      url: 'https://www.print.recordnews.co.za'
    },
    {
      type: 'online',
      title: 'Online Monitoring',
      description: 'Digital news and website coverage tracking',
      url: 'https://www.online.recordnews.co.za'
    },
    {
      type: 'social',
      title: 'Social Media Monitoring',
      description: 'Social platforms conversation tracking',
      url: 'https://www.social.recordnews.co.za'
    },
    {
      type: 'video',
      title: 'Video Monitoring',
      description: 'Video content and broadcast media tracking',
      url: 'https://www.video.recordnews.co.za'
    }
  ];

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>Complete Media Monitoring Solutions</h1>
          <p>Track, analyze, and understand your media presence across all platforms with Record News</p>
          <div className="hero-buttons">
            <a href="#services" className="btn btn-primary">Our Services</a>
            <a href="/about" className="btn btn-secondary">Learn More</a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services-section">
        <div className="container">
          <h2>Our Monitoring Platforms</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <ServiceCard key={index} service={service} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Enhance Your Media Monitoring?</h2>
          <p>Get in touch with our team to learn how we can help your business</p>
          <a href="/contact" className="btn btn-primary">Contact Us</a>
        </div>
      </section>
    </div>
  );
};

export default Landing;